import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdStrip({ placement = "footer" }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    api.get(`/advertisers/public?placement=${placement}`)
      .then(({ data }) => setAds(data.advertisers || []))
      .catch(() => setAds([]));
  }, [placement]);

  if (!ads.length) return null;

  const onClick = (ad) => {
    // Fire-and-forget click tracking
    api.post(`/advertisers/${ad.id}/click`).catch(() => {});
  };

  return (
    <div className="border-t border-black/5 py-6 bg-white" data-testid={`ad-strip-${placement}`}>
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="text-[10px] uppercase tracking-[0.24em] font-bold text-muted-foreground mb-3">
          Nos partenaires
        </div>
        <div className="flex flex-wrap items-center gap-6">
          {ads.map((ad) => (
            <a
              key={ad.id}
              href={ad.click_url}
              target="_blank"
              rel="noopener noreferrer sponsored"
              onClick={() => onClick(ad)}
              className="group inline-flex items-center gap-3 px-4 py-2 rounded-lg border border-black/10 bg-white hover:border-primary/40 hover:-translate-y-0.5 transition-transform"
              data-testid={`ad-${ad.id}`}
            >
              {ad.logo_url ? (
                <img src={ad.logo_url} alt={ad.name} className="h-6 w-auto object-contain" />
              ) : (
                <span className="grid place-items-center h-6 w-6 rounded-md bg-primary/10 text-primary text-[10px] font-bold">
                  {ad.name.slice(0, 2).toUpperCase()}
                </span>
              )}
              <div className="min-w-0">
                <div className="text-sm font-semibold group-hover:text-primary transition-colors leading-tight">
                  {ad.name}
                </div>
                {ad.tagline && (
                  <div className="text-[11px] text-muted-foreground leading-tight max-w-xs truncate">
                    {ad.tagline}
                  </div>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
